import Dustbin from '@/components/svgs/basic/dustbin';
import {TouchableOpacity, View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import {ACTIONS, COLORS, INDEX_TO_O} from '../constant';
import CartActionButton from '../component/cart-action-btn';
import theme from '@/style';
import DigitBall from '../component/digit-ball';
import {TextInput} from '@/components/basic/input-field';
import {CartListItem, LotteryMode} from '../mix-lottery-service';
import Tag from '../component/tag';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import NP from '@/components/utils/number-precision';
export interface CartItemProps {
  onDel?: () => void;
  onAction?: () => void;
  changeAmount?: (amount: string) => void;
}

const CartItem = ({
  modeID,
  odds,
  label,
  value,
  min = 20,
  max = 30,
  amount,
  type,
  selectPrize,
  onDel,
  changeAmount,
}: CartItemProps & CartListItem) => {
  const {t} = useTranslation();
  const [focus, setFocus] = React.useState(false);
  const webInputStyle = React.useMemo(
    () => ({
      ...stylesWeb.input,
      borderColor: focus ? theme.basicColor.primary : '#D8E0EA',
    }),
    [focus],
  );

  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.wrap}>
        <div style={stylesWeb.header}>
          <div style={stylesWeb.headerLeft}>
            <span style={stylesWeb.title}>
              {INDEX_TO_O[selectPrize]} Priz | {LotteryMode[modeID]}:
            </span>
            {modeID === LotteryMode['Two Side'] ||
            modeID === LotteryMode.FishPrawnCrab ? (
              <div style={stylesWeb.tagWrap}>
                <Tag label={label} backgroundColor={COLORS[type]} />
              </div>
            ) : (
              <div style={stylesWeb.ballList}>
                {value.split('').map((item, _i) => (
                  <div
                    key={_i}
                    style={{
                      ...stylesWeb.ball,
                      backgroundColor: COLORS[type.split('')[_i]],
                    }}>
                    {item}
                  </div>
                ))}
              </div>
            )}
            <span style={stylesWeb.title}>@</span>
            <span style={stylesWeb.odds}>{odds}</span>
          </div>
          <button onClick={onDel} style={stylesWeb.delBtn} type="button">
            <Dustbin />
          </button>
        </div>

        <div style={stylesWeb.amountRow}>
          <input
            value={`${amount}`}
            onChange={e => {
              const v = e.target.value;
              const regex = /^[0-9\b]+$/;
              if (regex.test(v) || !v) {
                changeAmount?.(v);
              }
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => {
              setFocus(false);
              if (Number(amount) < min) {
                changeAmount?.(`${min}`);
                globalStore.globalWaringTotal(
                  t('mix-lotto.tip.minAmount', {num: min}),
                );
              }
              if (Number(amount) > max) {
                changeAmount?.(`${max}`);
                globalStore.globalWaringTotal(
                  t('mix-lotto.tip.betMax', {num: max}),
                );
              }
            }}
            placeholder="Betting amount"
            style={webInputStyle}
          />
          <div style={stylesWeb.minMax}>
            <div style={stylesWeb.minMaxText}>Min Bet: {min}</div>
            <div style={stylesWeb.minMaxText}>Max Bet: {max}</div>
          </div>
        </div>

        <div style={stylesWeb.est}>
          {t('mix-lotto.label.est')}: {NP.times(Number(amount), Number(odds))}
        </div>

        <div style={stylesWeb.actionRow}>
          {ACTIONS.map((item, i) => (
            <CartActionButton
              key={i}
              value={item}
              disabled={!!max && max === 30}
              onPress={() => {
                if (item === 'MAX') {
                  if (max) {
                    changeAmount?.(`${max}`);
                  }
                } else {
                  const target = Number(amount) + Number(item);
                  if (target > max) {
                    globalStore.globalWaringTotal(
                      t('mix-lotto.tip.betMax', {num: max}),
                    );
                    return;
                  }
                  changeAmount?.(`${target}`);
                }
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <View
      style={[
        theme.padding.l,
        theme.borderRadius.xl,
        theme.margin.btms,
        // eslint-disable-next-line react-native/no-inline-styles
        {backgroundColor: '#F3F5F8'},
      ]}>
      <View
        style={[theme.flex.row, theme.flex.centerByCol, theme.flex.between]}>
        <View style={[theme.flex.row, theme.flex.centerByCol]}>
          <Text fontFamily="fontInterBold">
            {INDEX_TO_O[selectPrize]} Priz | {LotteryMode[modeID]}:
          </Text>
          {modeID === LotteryMode['Two Side'] ||
          modeID === LotteryMode.FishPrawnCrab ? (
            <Tag
              label={label}
              backgroundColor={COLORS[type]}
              style={[theme.margin.lrxxs]}
            />
          ) : (
            <View
              style={[
                theme.flex.row,
                theme.flex.centerByCol,
                theme.margin.lrxxs,
                {gap: theme.paddingSize.xxs},
              ]}>
              {value.split('').map((item, _i) => (
                <DigitBall
                  key={_i}
                  digit={item}
                  type={type.split('')[_i] as 'A' | 'B' | 'C' | 'D'}
                />
              ))}
            </View>
          )}

          <Text fontWeight="500">@</Text>
          <Text fontWeight="500" color={'#F15802'}>
            {odds}
          </Text>
        </View>
        <TouchableOpacity activeOpacity={0.8} onPress={onDel}>
          <Dustbin />
        </TouchableOpacity>
      </View>
      <View
        style={[
          theme.flex.row,
          theme.flex.centerByCol,
          theme.margin.tbl,
          {gap: theme.paddingSize.l},
        ]}>
        <TextInput
          value={`${amount}`}
          onValueChange={v => {
            const regex = /^[0-9\b]+$/;
            if (regex.test(v) || !v) {
              changeAmount?.(v);
            }
          }}
          containerStyle={[
            styles.inputContainer,
            // eslint-disable-next-line react-native/no-inline-styles
            {borderColor: focus ? theme.basicColor.primary : '#D8E0EA'},
          ]}
          placeholder="Betting amount"
          hasMax={false}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={() => {
            setFocus(false);
            if (Number(amount) < min) {
              changeAmount?.(`${min}`);
              globalStore.globalWaringTotal(
                t('mix-lotto.tip.minAmount', {num: min}),
              );
            }
            if (Number(amount) > max) {
              changeAmount?.(`${max}`);
              globalStore.globalWaringTotal(
                t('mix-lotto.tip.betMax', {num: max}),
              );
            }
          }}
          // eslint-disable-next-line react-native/no-inline-styles
          textInputStyle={{fontWeight: '700'}}
        />
        <View style={[theme.flex.flex1]}>
          <Text fontWeight="500">Min Bet: {min}</Text>
          <Text fontWeight="500">Max Bet: {max}</Text>
        </View>
      </View>
      <Text accent fontWeight="500">
        {t('mix-lotto.label.est')}: {NP.times(Number(amount), Number(odds))}
      </Text>
      <View
        style={[theme.flex.row, theme.margin.tops, {gap: theme.paddingSize.s}]}>
        {ACTIONS.map((item, i) => (
          <CartActionButton
            key={i}
            value={item}
            disabled={!!max && max === 30}
            onPress={() => {
              if (item === 'MAX') {
                if (max) {
                  changeAmount?.(`${max}`);
                }
              } else {
                const target = Number(amount) + Number(item);
                if (target > max) {
                  globalStore.globalWaringTotal(
                    t('mix-lotto.tip.betMax', {num: max}),
                  );
                  return;
                }
                changeAmount?.(`${target}`);
              }
            }}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  inputContainer: {
    borderWidth: 1,
    padding: 0,
    borderColor: '#D8E0EA',
    backgroundColor: '#fff',
    borderRadius: 8,
    flex: 1,
    marginBottom: 0,
    height: 40,
  },
});

export default React.memo(CartItem);

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    padding: '0.75rem',
    borderRadius: '0.75rem',
    marginBottom: '0.75rem',
    backgroundColor: '#F3F5F8',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.25rem',
  },
  title: {
    fontFamily: 'Inter-Bold',
    fontWeight: 700,
    color: '#31373D',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  tagWrap: {
    margin: '0 0.125rem',
  },
  ballList: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.125rem',
    margin: '0 0.125rem',
  },
  ball: {
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 700,
  },
  odds: {
    fontWeight: 500,
    color: '#F15802',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  delBtn: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  amountRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    margin: '0.75rem 0',
  },
  input: {
    flex: 1,
    height: '2.5rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    borderRadius: '0.5rem',
    padding: '0 0.75rem',
    fontWeight: 700,
    outline: 'none',
  },
  minMax: {
    flex: 1,
  },
  minMaxText: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
    color: '#31373D',
  },
  est: {
    color: theme.fontColor.accent,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
  },
  actionRow: {
    display: 'flex',
    gap: '0.5rem',
    marginTop: '0.5rem',
  },
};
